export const getFormattedVideoTitle = (title, statsVideo) => {
  if (title.includes('plays')) return title;
  const count = Array.isArray(statsVideo) ? statsVideo.length : 0;
  return `${title}, ${count} play${count === 1 ? '' : 's'}`;
};
